// Съобщи проблем / свържи се с поддръжката. Заявката отива в базата (вижда се
// в админ панела) и на имейл до info@livupp.com. Достъпно за всеки влязъл.

import React, { useEffect, useState } from 'react';
import { Linking, Pressable, Text, View } from 'react-native';
import { api } from '../api';
import { showError, showSuccess } from '../toast';
import { Button, Card, Input, Label, Muted, Screen, Title, COLORS } from '../ui';
import { t } from '../i18n';

// Функция, а не константа — етикетите се превеждат при рендиране (смяна на езика)
const getCategories = (): { key: string; label: string }[] => [
  { key: 'PROBLEM', label: t('🛠 Проблем') },
  { key: 'QUESTION', label: t('❓ Въпрос') },
  { key: 'IDEA', label: t('💡 Идея') },
  { key: 'OTHER', label: t('✉️ Друго') },
];

export default function SupportScreen({ navigation }: any) {
  const [category, setCategory] = useState('PROBLEM');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  // Имейл: питаме ГО само ако акаунтът още няма — така поддръжката може да отговори
  const [hasEmail, setHasEmail] = useState<boolean | null>(null);
  const [email, setEmail] = useState('');

  useEffect(() => {
    api('/me/profile')
      .then((r) => setHasEmail(!!r.email))
      .catch(() => setHasEmail(true)); // при съмнение не блокираме подаването
  }, []);

  const needsEmail = hasEmail === false;

  const submit = async () => {
    setLoading(true);
    try {
      await api('/support', {
        body: { category, message, ...(needsEmail && email.trim() ? { email: email.trim() } : {}) },
      });
      showSuccess(t('Благодарим! Получихме съобщението ви и ще се свържем с вас.'));
      navigation.goBack();
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen>
      <Title>{t('Свържете се с нас')}</Title>
      <Card>
        <Muted>
          {t('Опишете проблема, въпроса или идеята си — екипът на Livupp ще ви отговори по телефон или имейл.')}
        </Muted>

        <Label>{t('Тема')}</Label>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginBottom: 4 }}>
          {getCategories().map((c) => {
            const active = c.key === category;
            return (
              <Pressable
                key={c.key}
                onPress={() => setCategory(c.key)}
                style={{
                  paddingVertical: 8,
                  paddingHorizontal: 14,
                  borderRadius: 999,
                  backgroundColor: active ? COLORS.primary : COLORS.card,
                  borderWidth: 1,
                  borderColor: active ? COLORS.primary : COLORS.border,
                }}
              >
                <Text style={{ color: active ? '#fff' : COLORS.text, fontWeight: '600' }}>{c.label}</Text>
              </Pressable>
            );
          })}
        </View>

        {needsEmail && (
          <>
            <Label>{t('Вашият имейл')}</Label>
            <Input
              value={email}
              onChangeText={setEmail}
              autoCapitalize="none"
              keyboardType="email-address"
              placeholder="ime@poshta.bg"
            />
            <Muted>{t('Нямате въведен имейл. Ще го запазим в профила ви, за да ви отговорим.')}</Muted>
          </>
        )}

        <Label>{t('Съобщение')}</Label>
        <Input
          value={message}
          onChangeText={setMessage}
          multiline
          numberOfLines={5}
          placeholder={t('Опишете какво се случва…')}
          style={{ minHeight: 110, textAlignVertical: 'top' }}
        />

        <Button
          title={t('Изпрати')}
          onPress={submit}
          disabled={message.trim().length < 5 || (needsEmail && !email.includes('@'))}
          loading={loading}
        />
        <Muted>{t('Или директно: info@livupp.com')}</Muted>
        <Button title={t('Пиши на info@livupp.com')} variant="secondary" onPress={() => Linking.openURL('mailto:info@livupp.com')} />
      </Card>
    </Screen>
  );
}
